import { TableDomTraverser, VirtualWorksheet } from "@herbjoy/sheet-hotkeys";
import { FlexTableExtension } from "../flex-table";

const validFocusable = "input:not([type=checkbox]):not([disabled=disabled]):not([type=hidden])," +
    "[tabindex]:not([disabled=disabled])";

/**
 * An extension to the flex table that allows input cell key inputs
 * to navigate around the table as if it were an Excel worksheet.
 */
export class ExcelHotkeysExtension extends FlexTableExtension {
    /**
     * Construct a new instance of the extension with given options.
     * @param {any} options Options for constructing the extension.
     */
    constructor(options) {
        super();
        this.extensionOptions = options;
    }

    attach(flexTableContext) {
        super.attach(flexTableContext);
        this.worksheet = new VirtualWorksheet(flexTableContext.table, new TableDomTraverser(
            // Only allow DOM traversal between nodes containing a focusable element.
            el => !!el.querySelector(validFocusable)
        ), {
            inputSelector: validFocusable,
            inputValidator: () => true,
            ...this.extensionOptions
        });
        this.worksheet.attachToTable();
    }

    detach(flexTableContext) {
        if (this.worksheet) {
            this.worksheet.detachFromTable();
        }
        super.detach(flexTableContext);
    }
}
